module.exports = __webpack_public_path__ + "img/horizontal_7_1_9016.2ab86f0e.png";